import {Header} from '../components';

import {CreatePin} from '~/features/Auth/CreatePin';

export const CreatePinScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <div className="flex flex-1 justify-center items-center p-32">
        <CreatePin />
      </div>
    </div>
  );
};
